import z from "zod";
import { webappClient } from "../clients";
import { validateResponse } from "../validation";
import { format } from "date-fns/format";
import { SUPPORTED_ARRIVAL_STATUSES } from "../../settings/constants";

const flightSchema = z.object({
  airline_code: z.string().nullable(),
  airline_identifier: z.string().nullable(),
  airline_name: z.string().nullable(),
  arrival_airport_code: z.string().nullable(),
  delay_mins: z.number().nullable(),
  departure_airport_code: z.string().nullable(),
  flight_number: z.string().nullable(),
  local_arrival_at: z.string().nullable(),
  local_departure_at: z.string().nullable(),
  operating_airline_code: z.string().nullable(),
  humanized_arrival_status: z.enum(SUPPORTED_ARRIVAL_STATUSES).nullable(),
});

const flightsResponseSchema = z.object({
  flights: z.array(flightSchema),
});

export type RawFlight = z.infer<typeof flightSchema>;

export async function fetchFlights(
  localDepartureDate: Date | null,
  departureAirportCode?: string,
  arrivalAirportCode?: string,
  token?: string,
) {
  if (!localDepartureDate || !departureAirportCode || !arrivalAirportCode) {
    throw new Error("Invalid flight data parameters");
  }

  const data = await webappClient
    .get("api/flights/selector", {
      searchParams: {
        local_departure_date: format(localDepartureDate, "dd-MM-yyyy"),
        departure_airport_code: departureAirportCode,
        arrival_airport_code: arrivalAirportCode,
        token: token || "",
      },
    })
    .json();

  const result = validateResponse({
    data,
    schema: flightsResponseSchema,
    tag: "FlightSelector API response",
  });

  return result.flights;
}
